import { createTheme } from '@mui/material/styles';

export const minimalTheme = createTheme({
  spacing: 2,
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          margin: 2,
          padding: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            padding: '4px 8px',
            fontSize: '0.75rem'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '2px 8px',
          minWidth: 'auto',
          fontSize: '0.75rem'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: '2px 0'
        }
      }
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 12,
    h6: {
      fontSize: '0.9rem',
      fontWeight: 600
    },
    body2: {
      fontSize: '0.75rem'
    }
  }
});